import { Link } from "@tanstack/react-router";
import { Phone, Mail, MapPin, ShieldCheck, Truck, BadgeCheck } from "lucide-react";
import { SocialLinks } from "@/components/SocialLinks";
import logo from "@/assets/logo.png";

export function Footer() {
  return (
    <footer className="bg-navy text-white mt-24">
      {/* trust strip */}
      <div className="border-b border-white/10">
        <div className="container mx-auto px-4 py-8 grid grid-cols-1 sm:grid-cols-3 gap-6 text-center sm:text-left">
          <div className="flex items-center gap-3 justify-center sm:justify-start">
            <Truck className="h-8 w-8 text-teal" />
            <div>
              <p className="font-semibold text-white">Fast Delivery</p>
              <p className="text-sm text-white/70">All over Pakistan</p>
            </div>
          </div>
          <div className="flex items-center gap-3 justify-center sm:justify-start">
            <ShieldCheck className="h-8 w-8 text-teal" />
            <div>
              <p className="font-semibold text-white">Secure Checkout</p>
              <p className="text-sm text-white/70">Cash on Delivery available</p>
            </div>
          </div>
          <div className="flex items-center gap-3 justify-center sm:justify-start">
            <BadgeCheck className="h-8 w-8 text-gold" />
            <div>
              <p className="font-semibold text-white">Trusted Brand</p>
              <p className="text-sm text-white/70">Hundreds of happy customers</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={logo} alt="Trendora Marts" width={48} height={48} loading="lazy" className="h-12 w-12 object-contain bg-white/95 rounded-md p-1" />
            <div>
              <p className="font-serif text-lg text-white">Trendora Marts</p>
              <p className="text-xs uppercase tracking-widest text-gold">Smart Shopping</p>
            </div>
          </div>
          <p className="text-sm text-white/70 leading-relaxed">
            Trending gadgets, watches, kitchen tools and toys — delivered with care across Pakistan.
          </p>
        </div>

        <div>
          <h4 className="font-serif text-white mb-4 pb-2 border-b border-gold/40 inline-block">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="text-white/80 hover:text-teal transition-colors">Home</Link></li>
            <li><Link to="/shop" className="text-white/80 hover:text-teal transition-colors">Shop</Link></li>
            <li><Link to="/about" className="text-white/80 hover:text-teal transition-colors">About Us</Link></li>
            <li><Link to="/testimonials" className="text-white/80 hover:text-teal transition-colors">Reviews</Link></li>
            <li><Link to="/contact" className="text-white/80 hover:text-teal transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-white mb-4 pb-2 border-b border-gold/40 inline-block">Contact</h4>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2">
              <Phone className="h-4 w-4 text-teal mt-0.5 shrink-0" />
              <a href="tel:03707851120" className="hover:text-teal">0370-7851120</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 text-teal mt-0.5 shrink-0" />
              <a href="mailto:malikmuzammilfive@gmail.com" className="hover:text-teal break-all">malikmuzammilfive@gmail.com</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail className="h-4 w-4 text-teal mt-0.5 shrink-0" />
              <div>
                <span className="block text-[10px] uppercase tracking-wider text-white/60 mb-0.5">Business Email</span>
                <a href="mailto:trendoramarts052@gmail.com" className="hover:text-teal break-all">trendoramarts052@gmail.com</a>
              </div>
            </li>
            <li className="flex items-start gap-2">
              <MapPin className="h-4 w-4 text-teal mt-0.5 shrink-0" />
              <span>Lahore, Pakistan</span>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-serif text-white mb-4 pb-2 border-b border-gold/40 inline-block">Follow Us</h4>
          <SocialLinks variant="footer" className="justify-center sm:justify-start" />
          <p className="text-xs text-white/60 mt-6">
            Payment: Cash on Delivery (COD)
          </p>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-xs text-white/60">
        © {new Date().getFullYear()} Trendora Marts. All rights reserved.
      </div>
    </footer>
  );
}
